/**
 * @file: 工具函数
 * @author: wangzhenhai02@baidu.com
 * @Date: 2021-07-19 15:50:31
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-03-28 15:48:00
 * @FilePath: /console-znzs/src/utils/index.js
 */
import Vue from 'vue';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import {PLATFORM_KEY} from '@/znzs/src/constants';
import {constant} from '@/znzs/src/utils/enum';
/**
 * @description: 去除经过富文本中图片的width和height属性
 * @param {*} 富文本字符串
 * @return {*} 去掉宽高属性的富文本
 */
export const removeTinymceImgWidthHeight = str => (
    str
        ? str.replace(/<img[^>]*>/gi, (match, capture) => (match.replace(/(width="(.*?)")|(height="(.*?)")/ig, '')))
        : str);

/**
  * 时间戳转化
  * @param {*} timestamp  时间戳
  */
export const timestampToTime = timestamp => {
    if (timestamp == null || timestamp === '') {
        return '';
    }
    return dayjs(parseInt(timestamp, 10)).format('YYYY-MM-DD HH:mm:ss');
};

/**
 * @description: 去掉富文本标签
 * @param {*} html
 */
export const getSimpleText = html => {
    return html.replace(new RegExp('<.+?>', 'g'), '');
};

/**
 * @description: 格式话文件大小
 * @param {*} size
 */
export const formatFileSize = (size, accuracy = 2) => {
    let value = Number(size);
    if (size && !isNaN(value)) {
        const units = ['B', 'KB', 'MB', 'GB'];
        let index = 0;
        let k = value;
        if (value >= 1024) {
            while (k > 1024) {
                k = k / 1024;
                index++;
            }
        }
        return `${(k).toFixed(accuracy)}${units[index]}`;
    }
    return '-';
};

/**
 * xss防范，字符替换
 * @param {*} str
 * @returns
 */
export const xssSymbol = str => {
    return str
        // 针对&符号做特殊处理，如果&后面是html实体符号则对&转义，否则不做处理
        .replace(/&(#[0-9]{2,4}|[a-z]+);/gi, match => match.replace('&', '&amp;'))
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\'/g, '&#39;')
        .replace(/\"/g, '&quot;');
};

/**
 * 解析工单链接
 * url productId, questionId
 * @param {*} href
 * @return {object} url及params
 * https://ticket.bce.baidu.com/?fromai=1#/ticket/create~productId=171&questionId=688
 */
export const transformTicketParams = href => {
    const query = href.match(/(?:[~|?]).*$/);
    if (query && query[0]) {
        const params = query[0].match(/([a-zA-Z][a-zA-Z0-9]*)=([^?&~#]*)\b/g);
        const url = href.replace(query[0], '');
        if (params) {
            const result = params.reduce((obj, str) => {
                const [key, value] = str.split('=');
                obj[key] = value;
                return obj;
            }, {});

            return {
                url,
                params: result,
            };
        }
    }
    return {
        url: href,
        params: {},
    };
};

/**
 * @description 根据是否展示在当前平台过滤消息
 * @description https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/v3byE0p5qJ/e141074f353543#anchor-41d786d0-ad0c-11ed-a73e-05753aa4e5cc
 * @param {*} messageList
 * @returns
 */
export const filterMessage = messageList => messageList.filter(msg => (msg.show & PLATFORM_KEY) === PLATFORM_KEY);

/**
 * 检查当前状态是否在文心loading状态中
 * @param {*} store vuex的store
 * @returns
 */
export function beforeSend(store) {
    const loading = !!store.getters.isInWenxinLoading;
    if (loading) {
        Vue.prototype.$message({// 全局配置网络问题响应
            type: 'warning',
            message: '等待回复期间请勿发送其他问题',
            duration: 5000,
            showClose: true,
        });
    }
    return loading;
}

// 是否是官网文档链接
export function isOffcialDoc(link) {
    return constant.true.officalDoc.some(doc => link.startsWith(doc));
}

/**
 * 打开新的标签页
 * @param {*} link
 * @param {*} reopen
 * @param {*} useFeature 是否使用noopener noreferrer
 * @returns
 */
export function safeOpenTab(link = '', reopen = false, useFeature = true) {
    const newtab = window.top.open(
        link,
        reopen ? link : '_blank',
        useFeature ? 'noopener=yes,noreferrer=yes' : ''
    );
    return newtab;
}

/**
 * 添加页面卸载拦截
 */
export function loadEvent() {
    const handler = e => {
        e.preventDefault();
        e.returnValue = '';
        return '';
    };
    // 不支持IE9以下
    window.addEventListener('beforeunload', handler, false);
    return () => {
        window.removeEventListener('beforeunload', handler, false);
    };
}

/**
 * 用户相关信息
 */
export const user = {
    get name() {
        // 获取名为 'bce-login-display-name' 的 cookie 值，如果不存在则返回空字符串
        return Cookies.get('bce-login-display-name') || '';
    },
    get accountId() {
        return Cookies.get('ZNZS_ACCOUNT_ID') || '';
    },
};